import MyAccountLayout from './MyAccountLayout';

export default MyAccountLayout;
